import { injectShowsWidget } from './modules/shows/inject-shows'

export interface InjectCardsListWidgetArgs {
  widgets?: {
    shows?: {
      querySelector?: string
    }
  }
}

const WIDGET_ID = '#hulyo-cards-list-widget'

const initialConfig: Required<InjectCardsListWidgetArgs> = {
  widgets: {
    shows: {
      querySelector: WIDGET_ID,
    },
  },
}

export const injectCardsListWidget = (config?: InjectCardsListWidgetArgs) => {
  const normalizedConfig = { ...initialConfig, ...config }
  const showsSelector = normalizedConfig.widgets.shows?.querySelector

  // Detect widget type from container data attribute
  const container: HTMLElement | null = document.querySelector(showsSelector || WIDGET_ID)

  if (!container) {
    console.warn(`[Cards List SDK] Container wasn't found: ${showsSelector || WIDGET_ID}`)
    console.warn(`[Cards List SDK] Available elements with id:`, document.querySelectorAll('[id*="cards-list"]'))

    return
  }

  const widgetType = container.dataset.widgetType || 'shows'

  // Route to appropriate module handler
  if (widgetType === 'shows') {
    // injectShowsWidget is now async - fetch data on each render
    injectShowsWidget(container).catch((error) => {
      console.error('[Cards List SDK] Failed to inject shows widget:', error)
    })
  } else {
    console.warn(`[Cards List SDK] Unknown widget type: ${widgetType}`)
  }
}
